export default __webpack_public_path__ + "static/media/code-01.2f0d248d.svg";